const makePostContentCoverData = data => ({
  userId: data.userId,
  creatorId: data.creatorId,
  productId: data.productId,
  postId: data.postId
});

export { makePostContentCoverData };
